import React from 'react';
import { SUPPORT_EMAIL } from '../data/content';
export function Footer() {
  return <footer className="bg-canvasAlt" data-id="element-71" data-mp="3gezev8fo7z39">
      <div className="mx-auto max-w-2xl px-4 py-7 text-center sm:px-6" data-id="element-72" data-mp="3gg1025qei1yp">
        <p className="font-display text-xs font-black uppercase tracking-[0.16em] text-accent" data-id="element-73" data-mp="32oni2w855c5s">
          CM Digital Pro
        </p>
        <p className="mt-2 text-[0.7rem] leading-relaxed text-ink-subtle" data-id="element-74" data-mp="36pz9n7aks7gm">
          © 2026 CM Digital Pro — Todos los derechos reservados.
        </p>
        <p className="mt-1.5 text-[0.7rem] leading-relaxed text-ink-subtle" data-id="element-75" data-mp="38h7nghhhuo4">
          El contenido es educativo e informativo. No garantiza resultados
          económicos o profesionales específicos.
        </p>
        <nav aria-label="Enlaces legales" className="mt-3 flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-[0.7rem] text-ink-muted" data-id="element-76" data-mp="3qcnlavmn2v19">
          <a href="#terminos" className="transition-colors duration-150 ease-soft hover:text-accent" data-id="element-77" data-mp="2ey09e8qeiii6">
            Términos y Condiciones
          </a>
          <span className="text-ink-subtle" data-id="element-78" data-mp="3lbdb8osqm1jp">·</span>
          <a href="#privacidad" className="transition-colors duration-150 ease-soft hover:text-accent" data-id="element-79" data-mp="3gbqzykwgyvdj">
            Política de Privacidad
          </a>
          <span className="text-ink-subtle" data-id="element-80" data-mp="3q7lo1vjgpinp">·</span>
          <a href={`mailto:${SUPPORT_EMAIL}`} className="transition-colors duration-150 ease-soft hover:text-accent" data-id="element-81" data-mp="3qazpn1kaxnu3">
            Contacto
          </a>
        </nav>
      </div>
    </footer>;
}